import dayjs from 'dayjs'

export const DEFAULT_ADDITIONAL_BUFFER = 20
export const DEFAULT_ORDER_STOCK_UNTIL = () => dayjs().add(14, 'day')
export const DEFAULT_SALES_MODEL_PERIOD_FROM = dayjs().subtract(1, 'month')
export const DEFAULT_SALES_MODEL_PERIOD_TO = dayjs()
  .set('hour', 23)
  .set('minute', 59)
  .set('second', 59)
